import axios from "axios";
import { getItem, removeItem } from "./localStorageService"; // Assuming you have a removeItem function

const baseURL = `${process.env.REACT_APP_BASE_URL}/api/`;
const token = localStorage.getItem("token");
const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`
    // Add other default headers as needed
  },
});

// Add a request interceptor to add the authorization token to every request
api.interceptors.request.use(
  (config) => {
    const authToken = getItem("token"); // Assuming you store the token in localStorage
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      const serverMessage = error.response.data?.message;
      if (serverMessage === 'SESSION_INVALIDATED') {
        handleSessionDisplaced();
      } else {
        handleLogout();
      }
    }
    return Promise.reject(error);
  }
);

const handleLogout = () => {
  const token = localStorage.getItem("token") || localStorage.getItem("authToken");
  if (token) {
    // Fire-and-forget — invalidate session on backend so tokenVersion resets to 0
    fetch(`${process.env.REACT_APP_BASE_URL || ''}/api/users/logout`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {});
  }
  removeItem("token");
  removeItem("authToken");
};

// Called when another device logs in with the same credentials and kicks this session
const handleSessionDisplaced = () => {
  removeItem("token");
  removeItem("authToken");
  localStorage.removeItem("isAdminValue");
  localStorage.removeItem("userName");
  localStorage.removeItem("id");
  localStorage.removeItem("stateId");
  localStorage.removeItem("provinceId");

  // Show a visible alert then redirect so the user understands why they were logged out
  alert(
    "Your session has been ended because your account was logged in from another device. You will be redirected to the login page."
  );
  window.location.href = "/";
};

export const handleResponse = (response) => {
  if (response.status === 200 || response.status === 201) {
    const { statusCode, message, data } = response.data;
    if (statusCode === 200) {
      return data;
    } else {
      const error = new Error(message || "An error occurred");
      error.statusCode = statusCode;
      throw error;
    }
  } else {
    const error = new Error("Unexpected response status");
    error.statusCode = response.status;
    throw error;
  }
};

export default api;
